import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=890b8b9e&scoped=true&"
import script from "./DataModal.vue?vue&type=script&lang=ts&"
export * from "./DataModal.vue?vue&type=script&lang=ts&"
import style0 from "./DataModal.vue?vue&type=style&index=0&id=890b8b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "890b8b9e",
  null
  
)

export default component.exports